<script setup lang="ts">
import FireFoxLogo from '@clovyr/bed/assets/images/firefox.svg';

import Modal from '../elements/Modal.vue';

defineEmits(['close', 'continue']);
</script>

<template>
  <!-- Firefox warning -->
  <Modal @close="$emit('close')" size="narrow" max-on-mobile>
    <template v-slot:body>
      <div class="browser-warning">
        <ImageMedia :filename="FireFoxLogo" />
        <div>
          <h4>
            Firefox is not yet supported by Clovyr Code, but we're actively working to make it
            compatible soon!
          </h4>
          <Button label="continue anyway" @click="$emit('continue')" />
        </div>
      </div>
    </template>
  </Modal>
</template>

<style lang="scss" scoped>
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
.browser-warning {
  display: flex;
  align-items: center;
  padding: 1rem 0;

  > :first-child {
    margin-right: 2rem;
  }
  > :not(:first-child) {
    max-width: 30rem;
    display: flex;
    flex-direction: column;
    justify-content: center;

    h4 {
      padding: 0 1rem;
    }

    .button {
      margin-top: 1rem;
    }
  }
}
</style>
